module.exports = __webpack_public_path__ + "static/media/game-marksfont.17747043.png";